import { LogLevel } from '../app/services/logLevel.enum';
import { AppConfig } from './config-loader';

export const environment: AppConfig = {
  production: false,
  protocol: '',
  host: '',
  LogLevel: LogLevel.DEBUG,
  sharepointPickerClientId: '',
  sharepointEndpointHint: ''
}